import { createContext } from 'react';

/**
 * DocumentContext maintains state and operations for documents (resumes, variants, cover letters).
 */
export const DocumentContext = createContext(null);

export default DocumentContext;
